import React from 'react';
import { Helmet } from 'react-helmet';
import { buildCanonicalUrl } from '../utilities/canonicalUrls';

export default function SEO({canonical, title, description, type='website', noindex=false, structuredData=null}) {
    const robots = noindex ? 'noindex,nofollow' : 'index,follow';
    const canonicalUrl = canonical
        ? (canonical.startsWith('http') ? canonical : buildCanonicalUrl(canonical))
        : buildCanonicalUrl('/');
    return (
        <Helmet>
            <title>{title}</title>
            <link rel="canonical" href={canonicalUrl} />
            <meta name="robots" content={robots} />
            <meta name='description' content={description} />
            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonicalUrl} />
            <meta name="twitter:card" content={type} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            {structuredData ? (
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            ) : null}
        </Helmet>
    )
}
